import { combineReducers } from "redux";
import main from "./main";
import modal from "./modal";

export default combineReducers({
	main,
	modal
});
